"use client";

import { App, ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import type { ReactNode } from "react";
import { AuthProvider } from "@/auth/AuthContext";
import { CatalogProvider } from "@/catalog/CatalogContext";
import { AuthGate } from "@/components/AuthGate";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        token: {
          fontFamily: "var(--font-geist-sans), sans-serif",
          colorBgLayout: "#f4f6f8",
          borderRadius: 8,
        },
        components: {
          Layout: {
            bodyBg: "#f4f6f8",
            siderBg: "#ffffff",
          },
        },
      }}
    >
      <App>
        <AuthProvider>
          <CatalogProvider>
            <AuthGate>{children}</AuthGate>
          </CatalogProvider>
        </AuthProvider>
      </App>
    </ConfigProvider>
  );
}
